var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "StoneCutPrincess",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-stone-cut-princess","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M.5 243.7V.7h248.8v243.6l.2 5.1H.5v-5.7zm19.9-3.2h208.7l-17.7-11.3H38.2l-17.8 11.3zm194.1-20l16.2 10.3-11-18.3-11.9-6.2 6.5 13.8h.3v.4zm-184.6-7.9l-11 18.3L35 220.5v-.3h.3l6.5-13.8-11.9 6.2zm198.6-2.7l11.8 19.6V20.7l-11.8 19.6v169.6zM9.5 21.3v207.6l12-19.8V41.2l-12-19.9zm56 198.9h118L125 202.9l-59.5 17.3zm82.2-20l54.7 16.2-10-21.1-44.7 4.9zm-90-6.5l-10.6 22.4 56.1-16.3-45.5-6.1zM50.4 145l-15.8 54.9 19.9-10.4-4.1-44.5zM195 189.6l19.8 10.3-15.1-52.5-4.7 42.2zm-70 3.9l.4.1 60.9-6.7 7-62.1-.1-.4.1-.4-6.4-59-61.6-9h-.3l-.3-.1-60.3 10.3-6.9 58.2 5.6 60.9 61.5 8.3.4-.1zm77.6-69l16.9 59.1V70.8l-16.9 53.7zm-172.1-52v109.2l16.4-57.2-16.4-52zm2.1-23.3l18 57.1 5.3-44.9-23.3-12.2zm162.9 11.2v.2l4.6 42.1L217 49.3l-21.5 11.1zM46.8 33.3l11.7 24.8 46.4-7.9-58.1-16.9zm99.1 16.5l45.8 6.7L202.8 33l-56.9 16.8zm-82.3-21L125 46.6l60.3-17.8H63.6zm150.7 1l-6.7 14.1 11.9-6.2 11-18.3-16.2 10.4zM29.9 37.6l11.9 6.2-6.7-14.1-16.3-10.4 11.1 18.3zm6.4-17.8h176.8L229 9.6H20.4l15.9 10.2z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/stone-cut-princess.svg